import { makeStyles } from '@material-ui/core/styles'

export const borderStyles = makeStyles(({ palette, ...theme }) => ({
    '@global': {
        '.border-radius-0': {
            borderRadius: '0px !important',
            overflow: 'hidden',
        },
        '.border-radius-4': {
            borderRadius: '4px !important',
            overflow: 'hidden',
        },
        '.border-radius-8': {
            borderRadius: '8px !important',
            overflow: 'hidden',
        },
        '.border-radius-12': {
            borderRadius: '12px !important',
            overflow: 'hidden',
        },
        '.border-radius-padrao': { // incluído
            borderRadius: '20px !important', // antes estava 3
            //overflow: 'hidden', // retirado para resolver o problema da lista de seleção do Filtro que não estava aparecendo com todas as opções
        },
        '.border-radius-padrao-bottom': { // incluído
            borderBottomLeftRadius: '20px !important', // antes estava 3
            borderBottomRightRadius: '20px !important', // antes estava 3
            //overflow: 'hidden', // retirado para resolver o problema da lista de seleção do Filtro que não estava aparecendo com todas as opções
        },
        '.border-radius-padrao-cardGridEntradaDadosHeaderBody': { // incluído
            borderRadius: '0px !important',
            overflow: 'hidden',
        },
        '.border-radius-circle': { borderRadius: '50% !important' },
        '.border-none': { border: 'none !important' },
        '.border-transparent': { border: '1px solid transparent !important' },
        '.rounded': {
            borderRadius: '300px !important',
            overflow: 'hidden !important',
        },
        '.rounded-l': {
            borderTopLeftRadius: '300px !important',
            borderBottomLeftRadius: '300px !important',
            overflow: 'hidden !important',
        },
        '.rounded-r': {
            borderTopRightRadius: '300px !important',
            borderBottomRightRadius: '300px !important',
            overflow: 'hidden !important',
        },
    },
}))
